import React, {Component} from 'react';
import {SanitizeClassNames} from '../../common';
import NoteService from '../../api/services/NoteService';
import moment from 'moment';

import './ClientNotesView.css';
import {TextArea, Button, FormDataObj} from '../../components/FormUI';
import ClinicService from '../../api/services/ClinicService';


export default class ClientNotesView extends Component {
	state = {};
	form = new FormDataObj();

	constructor(props) {
		super(props);
		this.service = new NoteService(this.props.clientId);
	}

	componentDidMount() {
		this.loadNotes();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.clientId != this.props.clientId) {
			this.loadNotes();
		}
	}

	loadNotes() {
		if (this.props.clientId) {
			if (this.service.clientId != this.props.clientId) {
				this.service = new NoteService(this.props.clientId);
			}
			this.service.getNotes().then((notes) => {
				notes.sort((a, b) => {
					if (moment(a.createDate).isSame(moment(b.createDate))) return 0;
					return (moment(a.createDate).isBefore(moment(b.createDate))) ? 1 : -1;
				});
				this.setState({notes: notes});
			})
		}
	}

	getNoteList() {
		let list = this.state.notes || [];

		return list.map((note) => {
			return <NoteView key={note.clientNoteId} {...note} />;
		})
	}

	handleAddNote = () => {
		this.setState({isBusy: true})
		this.service.addNote(this.form.data.note).then((note) => {
			console.log("Note Added: ", note);
			this.form.setValue('note', '');
			let notes = this.state.notes || [];
			notes.unshift(note);

			this.setState({notes: notes, isBusy: false, noteInputVisible: false, error: null});
		}).catch((e) => {
			this.setState({isBusy: false, error: e.error})
		})
	}

	toggleShowNoteInput = () => {
		this.setState({noteInputVisible: !this.state.noteInputVisible, error: null});
	}


	render() {
		let saveCancel = (this.state.isBusy) ? <div>Saving... <span className="Select-loading"></span></div> :
			<div><span onClick={this.handleAddNote}>Save</span>&nbsp;&nbsp;&nbsp;&nbsp;<span
				onClick={this.toggleShowNoteInput}>Cancel</span></div>;
		let noteAdd = <div className='btn-add-note'>{(this.state.noteInputVisible) ? <div>{saveCancel}</div> :
			<span onClick={this.toggleShowNoteInput}>Add Note +</span>}</div>

		return (
			<div className={SanitizeClassNames(this, 'client-notes')}>
				{noteAdd}
				{this.state.noteInputVisible ? <div className='note-input'>
					<TextArea form={this.form} name='note' onDom={(r) => {
						if (r) {
							r.focus()
						}
					}} error={this.state.error}/>
				</div> : null}
				<div className='notes-list'>{this.getNoteList()}</div>

			</div>
		)
	}
}

class NoteView extends Component {
	render() {
		let author = ClinicService.GetDrById(this.props.userId);
		return (
			<div className='note'>
				<div className='note-author'>Authored by: {author.fullName}</div>
				<div className='note-date'>{moment(this.props.createDate).format('ddd MMMM Do YYYY, h:mma')}</div>
				<div className='note-text'>{this.props.note}</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/Clients/ClientNotesView.js